import gql from 'graphql-tag';

import { cardCategoryDetails } from '../fragments/cardCategoryDetails';

const getCardCategoriesQuery = gql`
  query getCardCategoriesQuery(
    $offset: Int = 0
    $limit: Int = 20
    $name: String
  ) {
    cardCategories(slice: { offset: $offset, limit: $limit }, name: $name) {
      total
      records {
        ...cardCategoryDetails
      }
    }
  }
  ${cardCategoryDetails}
`;

export default getCardCategoriesQuery;
